import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ContactSiteData } from './contactSite.api'
import { UserData } from './user.api'

export interface CustomerData {
  id: number
  siteId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  name: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  isDeleted: boolean
  updatedUser?: UserData
}

const routes = {
  search: '/customers/search',
  listSites: '/customers/{id}/sites'
}

export default {
  search (customer: string, callback: ResponseCallback<CustomerData[]>) {
    const params = { customer }
    api.get(routes.search, params, callback)
  },

  listSites (id: number, callback: ResponseCallback<ContactSiteData[]>) {
    const url = routeUtil.replaceParams(routes.listSites, { id })
    api.get(url, {}, callback)
  }
}
